const CARD_FORM = 'CARD_FORM';
export const SET_SELECTED_CARD = `${CARD_FORM}/SET_SELECTED_CARD`;
export const SET_CARD_TO_PAY = `${CARD_FORM}/SET_CARD_TO_PAY`;
export const INIT_CARD_FORM = `${CARD_FORM}/INIT_CARD_FORM`;
export const INIT_CARD_FORM_ADDRESS = `${CARD_FORM}/INIT_CARD_FORM_ADDRESS`;
export const RESET_CARD_FORM = `${CARD_FORM}/RESET_CARD_FORM`;
export const UPDATE_CARD_FORM = `${CARD_FORM}/UPDATE_CARD_FORM`;
export const ON_CHANGE_CARD_FORM = `${CARD_FORM}/ON_CHANGE_CARD_FORM`;
export const SET_SUBMIT_CARD_FORM = `${CARD_FORM}/SET_SUBMIT_CARD_FORM`;
export const SET_SUBMIT_EDIT_FORM = `${CARD_FORM}/SET_SUBMIT_EDIT_FORM`;
export const TOUCH_ALL = `${CARD_FORM}/TOUCH_ALL`;
export const TOUCH_ADDRESS = `${CARD_FORM}/TOUCH_ADDRESS`;
export const CLEAR_ALL_CARD_FORM_TOUCHED = `${CARD_FORM}/CLEAR_ALL_CARD_FORM_TOUCHED`;
export const CLEAR_CUSTOMER_ADDRESS_TOUCHED = `${CARD_FORM}/CLEAR_CUSTOMER_ADDRESS_TOUCHED`;
export const SET_CARD_FORM_ERROR = `${CARD_FORM}/SET_CARD_FORM_ERROR`;
export const CLEAR_ALL_CARD_FORM_ERRORS = `${CARD_FORM}/CLEAR_ALL_CARD_FORM_ERRORS`;
export const CLEAR_CARD_FORM_ERRORS = `${CARD_FORM}/CLEAR_CARD_FORM_ERRORS`; // clear specific fields
export const SET_CARD_FORM_VIEW = `${CARD_FORM}/SET_VIEW`;
export const UPDATE_EDIT_PRISTINE = `${CARD_FORM}/UPDATE_EDIT_PRISTINE`;

export const ALERT_WAS_SHOWN = 'ALERT_WAS_SHOWN';
